import { AttachFile } from "@mui/icons-material";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Chip, Grid2 } from "@mui/material";
import { ColDef, EditableCallbackParams } from "ag-grid-enterprise";
import React from "react";
import { dxtToLocalServerTime } from "../../../../services";

type Props = {
	showContextMenu: Function;
	allowAttachments?: boolean;
	withAssetFilter?: "tree" | "selector";
	showShiftCrew?: boolean;
};

export const useTableData = ({
	showContextMenu,
	allowAttachments,
	withAssetFilter,
	showShiftCrew,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "CreateTimestamp",
			headerName: "Created",
			flex: 2,
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data.CreateTimestamp, "MM/dd/yy HH:mm"),
		},

		// show only if attachments are allowed
		...(withAssetFilter
			? [
					{
						field: "AssetName",
						headerName: "Asset",
						sortable: true,
						flex: 2,
						minWidth: 70,
						wrapText: true,
						autoHeight: true,
					},
				]
			: []),

		{
			field: "Title",
			headerName: "Title",
			flex: 4,
		},
		{
			field: "Author",
			headerName: "Created By",
			flex: 2,
		},

		// show only if shift-crew is allowed
		...(showShiftCrew
			? [
					{
						field: "Shift",
						headerName: "Shift",
						sortable: false,
						flex: 1,
						minWidth: 60,
						maxWidth: 60,
					},
					{
						field: "Crew",
						headerName: "Crew",
						sortable: false,
						flex: 1,
						minWidth: 60,
						maxWidth: 60,
					},
				]
			: []),

		// show only if attachments are allowed
		...(allowAttachments
			? [
					{
						field: "AttachmentCount",
						headerName: "", // Remove text, use custom header component
						flex: 1,
						headerComponent: () => (
							<div
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "100%",
									width: "100%",
									textAlign: "center",
								}}
							>
								<AttachFile style={{ fontSize: 18, color: "#666" }} />
							</div>
						),
						cellRenderer: (params: EditableCallbackParams) => {
							const count = params.data.AttachmentCount || 0;
							if (count === 0) {
								return null;
							}
							return (
								<div
									style={{
										display: "flex",
										alignItems: "center",
										height: "100%",
										justifyContent: "center",
									}}
								>
									<Chip
										icon={<AttachFile style={{ fontSize: 16 }} />}
										label={count}
										size="small"
										variant="outlined"
										color="primary"
									/>
								</div>
							);
						},
					},
				]
			: []),

		{
			field: "Content",
			headerName: "Content",
			hide: true,
		},
		{
			headerName: "",
			flex: 1,
			wrapText: false,
			autoHeight: false,
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							size={{ md: 12, xs: 12 }}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								fullWidth
								onClick={(e) =>
									showContextMenu(e, params.data, "logbookEntryContext")
								}
								size="small"
							>
								<FormatListBulletedSharpIcon
									style={{ height: "auto" }}
									color="action"
								/>
							</Button>
						</Grid2>
					</Grid2>
				);
			},
		},
	];
	return { columnDefs };
};
